export enum ProductionMeasurement {
	product_size = 'Product Size',
	inside = 'Inside',
	outside = 'Outside',
	score_line = 'Score Line',
}

export enum ThProductionMeasurement {
	product_size = 'ขนาดสินค้า',
	inside = 'ขนาดภายใน',
	outside = 'ขนาดภายนอก',
	score_line = 'ขนาดตามทับเส้น Score Line',
}
